(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('consortium-tributos-devolucion', {
                parent: 'entity',
                url: '/consortium-tributos-devolucion?page&sort&search',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_CONSORTIUM'],
                    pageTitle: 'ConsortiumTributosDevolucion'
                },
                views: {
                  'content@': {
                    templateUrl: 'app/entities/consortium-tributos/consortium-tributos-devolucion/consortium-tributos-devolucion.html',
                    controller: 'ConsortiumTributosDevolucionController',
                    controllerAs: 'vm'
                  }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }]
                }
            })
            .state('consortium-tributos-devolucion.new', {
                parent: 'consortium-tributos-devolucion',
                url: '/new',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                views: {
                  'content@': {
                    templateUrl: 'app/entities/consortium-tributos/consortium-tributos-devolucion/consortium-tributos-devolucion-new.html',
                    controller: 'ConsortiumTributosDevolucionNewController',
                    controllerAs: 'vm'
                  }
                },
                ncyBreadcrumb: {
                      label: 'Nuevo',
                      parent: 'consortium-tributos-devolucion'
                },
                resolve: {
                    entity: function() {
                        return {
                            id: null
                        };
                    },
                    previousState: ["$state", function ($state) {
                          var currentStateData = {
                              name: $state.current.name || 'consortium-tributos-devolucion',
                              params: $state.params,
                              url: $state.href($state.current.name, $state.params)
                          };
                          return currentStateData;
                    }]
                }
            }).state('consortium-tributos-devolucion.edit', {
                parent: 'consortium-tributos-devolucion',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_CONSORTIUM'],
                    pageTitle: 'ConsortiumTributosDevolucion'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/consortium-tributos/consortium-tributos-devolucion/consortium-tributos-devolucion-detail.html',
                        controller: 'ConsortiumTributosDevolucionDetailController',
                        controllerAs: 'vm'
                    }
                },
                ncyBreadcrumb: {
                      label: 'Lista',
                      parent: 'consortium-tributos-devolucion'
                },
                resolve: {
                    entity: ['$stateParams', 'ConsortiumTributosDevolucion', function($stateParams, ConsortiumTributosDevolucion) {
                        return ConsortiumTributosDevolucion.get({
                            id: $stateParams.id
                        }).$promise;
                    }],
                    previousState: ["$state", function($state) {
                        var currentStateData = {
                            name: $state.current.name || 'consortium-tributos-devolucion',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            });
    }

})();
